import { render, staticRenderFns } from "./multiEdit.vue?vue&type=template&id=15ded630&scoped=true&"
import script from "./multiEdit.vue?vue&type=script&lang=js&"
export * from "./multiEdit.vue?vue&type=script&lang=js&"
import style0 from "./multiEdit.vue?vue&type=style&index=0&id=15ded630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ded630",
  null
  
)

export default component.exports